import React, { useState, useEffect } from 'react';
import {
  Box, Card, CardContent, Typography,
  Grid, CircularProgress, Alert, Chip,
  IconButton, Avatar, Button
} from '@mui/material';
import { MusicNote, Share, Favorite, Comment, Public } from '@mui/icons-material';
import api from '../services/api';

const TikTokFeed = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchFeed();
  }, []);

  const fetchFeed = async () => {
    try {
      const response = await api.get('/social/tiktok?limit=20');
      setVideos(response.data.data || []);
    } catch (err) {
      setError('TikTok feed coming soon! Follow us on TikTok for updates.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress sx={{ color: '#000' }} />
      </Box>
    );
  }

  return (
    <Box sx={{ py: 6, px: { xs: 2, md: 4 }, maxWidth: 1200, mx: 'auto' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 4 }}>
        <MusicNote sx={{ fontSize: 40, color: '#000', mr: 2 }} />
        <Typography variant="h4" fontWeight={700} color="#1a237e">
          TikTok Feed
        </Typography>
        <Chip
          icon={<Public />}
          label="Live"
          color="success"
          size="small"
          sx={{ ml: 2 }}
        />
      </Box>

      {error || videos.length === 0 ? (
        <Card sx={{ borderRadius: '20px', p: 4, textAlign: 'center', bgcolor: '#fdfbf6' }}>
          <MusicNote sx={{ fontSize: 60, color: '#000', mb: 2 }} />
          <Typography variant="h6" color="#1a237e" gutterBottom>
            TikTok Feed Coming Soon
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            Follow us on TikTok for the latest videos!
          </Typography>
          <Button
            variant="contained"
            href="https://tiktok.com/@natisguesthouse"
            target="_blank"
            startIcon={<MusicNote />}
            sx={{
              bgcolor: '#000',
              borderRadius: '50px',
              textTransform: 'none',
              px: 4,
              '&:hover': { bgcolor: '#333' }
            }}
          >
            Follow on TikTok
          </Button>
        </Card>
      ) : (
        <Grid container spacing={3}>
          {videos.map((video, index) => (
            <Grid item xs={12} sm={6} md={4} key={video.id || index}>
              <Card sx={{ borderRadius: '20px', boxShadow: '0 8px 25px rgba(0,0,0,0.1)' }}>
                <CardContent>
                  <Box display="flex" alignItems="center" mb={2}>
                    <Avatar sx={{ bgcolor: '#000', mr: 2 }}>
                      <MusicNote />
                    </Avatar>
                    <Box>
                      <Typography variant="subtitle1" fontWeight={700}>
                        Nati's Guesthouse
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {video.created_time ? new Date(video.created_time).toLocaleDateString() : 'Just now'}
                      </Typography>
                    </Box>
                  </Box>

                  <Typography variant="body2" paragraph>
                    {video.description || 'Check out this video!'}
                  </Typography>

                  <Box sx={{
                    bgcolor: '#f5f5f5',
                    borderRadius: 2,
                    p: 3,
                    textAlign: 'center',
                    mb: 2
                  }}>
                    <MusicNote sx={{ fontSize: 48, color: '#666' }} />
                    <Typography variant="caption" display="block" color="text.secondary">
                      TikTok Video
                    </Typography>
                  </Box>

                  <Box display="flex" gap={3} mt={2}>
                    <Box display="flex" alignItems="center">
                      <Favorite fontSize="small" sx={{ mr: 0.5, color: 'red' }} />
                      <Typography variant="caption">0</Typography>
                    </Box>
                    <Box display="flex" alignItems="center">
                      <Comment fontSize="small" sx={{ mr: 0.5 }} />
                      <Typography variant="caption">0</Typography>
                    </Box>
                    <IconButton size="small">
                      <Share fontSize="small" />
                    </IconButton>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default TikTokFeed;